import { createContext, useState, useReducer, useRef, useEffect } from 'react';

import { useNavigate, Link } from "react-router-dom";

export const ClientContext = createContext({
  slctdCase: [],
  setSelectedCase: () => {},
  slctdClient: [],
  setSelectedClient: () => {}
});

function clientReducer(state, action) {
  return state;
}


export function ClientContextProvider({ children }) {

  const [clientState, clientDispatch] = useReducer(
    clientReducer,
    {
      slctdCase: [],
    }
  );

  
  const [selectedCase, setSelectedCase] = useState({
    slctdCase: [],
  });

    
  const [selectedClient, setSelectedClient] = useState({
    slctdClient: [],
  });

  

  function handleChangeOfCase(caseSelected) {
    setSelectedCase((selectedCase) => {

      const updatedCase = [caseSelected, ...selectedCase.slctdCase];

      console.log ( 'before updatedCase=', updatedCase);

      return {
        slctdCase: updatedCase,
      };
    });
  }


  
  function handleChangeOfClient(clientSelected) {
    setSelectedClient((selectedClient) => {

      const updatedClient = [clientSelected, ...selectedClient.slctdClient];

      console.log ( 'before updatedClient=', updatedClient);

      return {
        clntAcct: updatedClient,
      };
    });
  }


  

  const ctxValue = {
    slctdCase: selectedCase.slctdCase,
    changeCase: handleChangeOfCase,
    slctdClient: selectedClient.slctdClient,
    changeClient: handleChangeOfClient,
  };

  return (
    <ClientContext.Provider value={ctxValue}>{children}</ClientContext.Provider>
  );
}